/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApiProductV7_ProductType {
    CITY_TICKET = 'CITY_TICKET',
    EXTRA = 'EXTRA',
    SHOP = 'SHOP',
    CONNECTION = 'CONNECTION',
    RESERVATION_ONLY = 'RESERVATION_ONLY',
}
